export default {
    name: "Console Booking",
    meta: {
        icon: "directions_boat",
        expanded: true,
        auth: true,
    },
    departmentName: "Console Booking",
    finalPagePermision: "Console_Booking_Dash",
    children: [{
        name: "Console Booking Details",
        path: "/consoleBooking",
        permissionName: 'Console_Booking_Dash',
        keywords: ['Console Booking Details ', 'Console_Booking_Dash'],
        meta: {
            icon: "directions_boat",
            auth: true,
        },
        component: require("../component/consoleBooking/ConsoleBooking.vue"),
        finalPagePermision: "Console_Booking_Dash",
    },
    {
        name: "Booking Response Dashboard",
        path: "/booking-resp-dash",
        permissionName: 'Console_Booking_Dash',
        keywords: ['Console Booking Details ', 'Console_Booking_Dash', 'Booking Response Dashboard'],
        meta: {
            icon: "directions_boat",
            auth: true,
        },
        component: require("../component/Pricing/bookingRespDash.vue"),
        finalPagePermision: "Console_Booking_Dash",
    },
    {
        name: "Contract Dashboard",
        path: "/contract-dash",
        permissionName: 'Console_Booking_Dash',
        keywords: ['Console Booking Details ', 'Console_Booking_Dash', 'Booking Response Dashboard','Contract Dashboard'],
        meta: {
            icon: "directions_boat",
            auth: true,
        },
        component: require("../component/consoleBooking/vesselWiseContractDashboard.vue"),
        // component: require("../component/consoleBooking/rateWiseContractDashboard.vue"),
        finalPagePermision: "Console_Booking_Dash",
    },
    {
        name: "Booking Approval Log",
        path: "/get-cb-approval-log",
        permissionName: 'Console_Booking_Dash',
        keywords: ['Console Booking Details ', 'Console_Booking_Dash', 'Booking Approval Log'],
        meta: {
            icon: "history",
            auth: true,
        },
        component: require("../component/consoleBooking/bookingApprovalLogs.vue"),
        finalPagePermision: "Console_Booking_Dash",
    },
    ],
};


// WEBPACK FOOTER //
// ./src/sidebar/consBooking.js